import { Logger } from "../server/logger"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { getStore } from "./redux"
import { getAuthUserId, getSelectedAccountId, getUserRole } from "../components/auth/selectors"

export const logger = {
    info: (message: string, data?: any) => {
        const attributes = getLogContext()
        Logger.info(message, data, attributes)
    },

    warn: (message: string, data?: any, error?: any) => {
        const attributes = getLogContext()
        Logger.warn(message, data, error, attributes)
    },

    error: (message: string, data?: any, error?: any) => {
        const attributes = getLogContext()
        Logger.error(message, data, error, attributes)
    },
}

type LoggerCtx = {
    accountId?: Maybe<string>
    userId?: Maybe<string>
    role?: Maybe<string>
}

export const getLogContext = (): LoggerCtx => {
    const state = getStore()?.getState()
    return {
        accountId: state ? getSelectedAccountId(state) : null,
        userId: state ? getAuthUserId(state) : null,
        role: state ? getUserRole(state) : null,
    }
}
